import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { StringValidator } from 'src/core/validators/shared/string.validator';

@Component({
    selector: 'ca-teams-integration-settings',
    templateUrl: './teams-integration-settings.component.html',
    styleUrls: ['./teams-integration-settings.component.scss'],
    standalone: false
})
export class TeamsIntegrationSettingsComponent implements OnInit {
  form: FormGroup;

  private readonly prefix = 'TeamsIntegration';
  private readonly sourceName = `${this.prefix}.SourceName`;
  private readonly encryptionCertificateId = `${this.prefix}.EncryptionCertificateId`;
  private readonly tenantId = `${this.prefix}.TenantId`;
  private readonly publicKey = `${this.prefix}.PublicKey`;
  private readonly privateKey = `${this.prefix}.PrivateKey`;
  private readonly clientId = `${this.prefix}.ClientId`;
  private readonly clientSecret = `${this.prefix}.ClientSecret`;
  private readonly groupId = `${this.prefix}.GroupId`;

  constructor(
    private fb: FormBuilder,
    private config: ConfigStateService,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService
  ) {
    this.form = this.fb.group({
      sourceName: this.fb.group({
        name: this.sourceName,
        value: [
          this.config.getSetting(this.sourceName),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      tenantId: this.fb.group({
        name: this.tenantId,
        value: [
          this.config.getSetting(this.tenantId),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      clientId: this.fb.group({
        name: this.clientId,
        value: [
          this.config.getSetting(this.clientId),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      clientSecret: this.fb.group({
        name: this.clientSecret,
        value: [
          this.config.getSetting(this.clientSecret),
          {
            validators: [StringValidator.whitespace],
          },
        ],
      }),
      publicKey: this.fb.group({
        name: this.publicKey,
        value: [
          this.config.getSetting(this.publicKey),
          {
            validators: [StringValidator.whitespace],
          },
        ],
      }),
      privateKey: this.fb.group({
        name: this.privateKey,
        value: [
          this.config.getSetting(this.privateKey),
          {
            validators: [StringValidator.whitespace],
          },
        ],
      }),
      encryptionCertificateId: this.fb.group({
        name: this.encryptionCertificateId,
        value: [
          this.config.getSetting(this.encryptionCertificateId),
          {
            validators: [StringValidator.whitespace],
          },
        ],
      }),
      groupId: this.fb.group({
        name: this.groupId,
        value: [
          this.config.getSetting(this.groupId),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
    });
  }

  ngOnInit(): void {}

  onSubmitForm(eventArgs): void {
    if (!this.form.valid) {
      return;
    }

    const settings: ConfigurationSettingsDto[] = [];

    settings.push({
      settingName: this.form.get('sourceName').get('name').value,
      settingValue: this.form.get('sourceName').get('value').value,
    });

    settings.push({
      settingName: this.form.get('tenantId').get('name').value,
      settingValue: this.form.get('tenantId').get('value').value,
    });

    settings.push({
      settingName: this.form.get('clientId').get('name').value,
      settingValue: this.form.get('clientId').get('value').value,
    });

    if (this.form.get('clientSecret').get('value').value) {
      settings.push({
        settingName: this.form.get('clientSecret').get('name').value,
        settingValue: this.form.get('clientSecret').get('value').value,
      });
    }

    settings.push({
      settingName: this.form.get('groupId').get('name').value,
      settingValue: this.form.get('groupId').get('value').value,
    });

    if (this.form.get('publicKey').get('value').value) {
      settings.push({
        settingName: this.form.get('publicKey').get('name').value,
        settingValue: this.form.get('publicKey').get('value').value,
      });
    }
    if (this.form.get('privateKey').get('value').value) {
      settings.push({
        settingName: this.form.get('privateKey').get('name').value,
        settingValue: this.form.get('privateKey').get('value').value,
      });
    }

    if (this.form.get('encryptionCertificateId').get('value').value) {
      settings.push({
        settingName: this.form.get('encryptionCertificateId').get('name').value,
        settingValue: this.form.get('encryptionCertificateId').get('value').value,
      });
    }

    this.settingService.saveSetting(settings).subscribe(res => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
      );
    });
  }
}
